import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { BrandEnum, ProductShoppingFilterEnum, ProductSortTypeOrderEnum } from 'src/app/core/dtos/enum';
import { FilterSortData } from '../filter-sort-data';

@Component({
  selector: 'app-filter-sort-panel',
  templateUrl: './filter-sort-panel.component.html',
  styleUrls: ['./filter-sort-panel.component.scss']
})
export class FilterSortPanelComponent implements OnDestroy, OnInit {

  @Input() topPanel: boolean;
  @Input() brandId: BrandEnum;
  @Input() filterSortData: FilterSortData;
  @Output() changeFilterSort: EventEmitter<FilterSortData> = new EventEmitter();
  filterSortSubscription: Subscription;
  filter: number;
  sort: number;

  productShoppingFilters = [
    { value: ProductShoppingFilterEnum.TestTakerStudyMaterial, title: "Test Taker Study Materials" },
    { value: ProductShoppingFilterEnum.PrintMaterial, title: "Print Materials(Paperback)" },
    { value: ProductShoppingFilterEnum.TeacherResource, title: "Teacher Resources" },
    { value: ProductShoppingFilterEnum.CELPIPGeneral, title: "Study Materials for CELPIP-General Test" },
    { value: ProductShoppingFilterEnum.CELPIPLS, title: "Study Materials for CELPIP-General LS Test" },
  ];

  productSortTypeOrder = [
    { value: ProductSortTypeOrderEnum.PopularityHighToLow, title: "Default" },
    { value: ProductSortTypeOrderEnum.PopularityHighToLow, title: "Popularity - High To Low" },
    { value: ProductSortTypeOrderEnum.PopularityLowToHigh, title: "Popularity - Low To High" },
    { value: ProductSortTypeOrderEnum.PriceHighToLow, title: "Price - High To Low" },
    { value: ProductSortTypeOrderEnum.PriceLowToHigh, title: "Price - Low To High" }
  ];

  constructor() {
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  ngOnInit(): void {
    this.filterSortData = this.filterSortData || { filter: ProductShoppingFilterEnum.TestTakerStudyMaterial, sort: ProductSortTypeOrderEnum.PopularityHighToLow };
  }

  changeFilter() {
    this.changeFilterSort.emit(this.filterSortData);
  }

  changeSort() {
    this.changeFilterSort.emit(this.filterSortData);
  }

  ngOnDestroy(): void {
    this.filterSortSubscription?.unsubscribe();
  }

}
